import { useQuery } from '@tanstack/react-query';
import { api } from 'modules/global/adapters';
import { DashboardMetricType } from 'modules/transport-operator/adapters/dashboard/queries';

export const useDashboardRequest = () => {
  return useQuery(['dashboard'], () => api.dashboard.getReleasePartyDashboard());
};

export const useGetContainersByDashboardMetric = (
  metricType: DashboardMetricType,
  enabled: boolean
) => {
  return useQuery(
    ['containersByDashboardMetric', metricType],
    () => api.dashboard.getContainersByDashboardMetric({ metricType }),
    {
      enabled,
    }
  );
};
